import { render, staticRenderFns } from "./EditFeedbackDialog.vue?vue&type=template&id=8be4311c"
import script from "./EditFeedbackDialog.vue?vue&type=script&lang=js"
export * from "./EditFeedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./EditFeedbackDialog.vue?vue&type=style&index=0&id=8be4311c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports